import { MenuAction } from "./menu.action";

export const menuMessageContext = {
	fetch: MenuAction.fetchAllByName.type,
};
